/**
 * Runtime configuration.
 *
 * Vite inlines these at build time, so a kiosk or kitchen tablet needs no
 * config file on the device — the deployed bundle already knows its branch.
 */
export const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:8787'
export const REALTIME_URL = import.meta.env.VITE_REALTIME_URL ?? 'ws://localhost:8788'
export const BRANCH_ID = import.meta.env.VITE_BRANCH_ID ?? 'N'
